var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrownPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.185 16.72c0-.637.25-1.248.696-1.699a2.365 2.365 0 011.681-.704h1.314l.033-9.582h-.033a2.28 2.28 0 01-.985-.23l-3.767 7.39-4.738-3.188c-.204.365-.501.67-.86.881a2.326 2.326 0 01-1.183.323h-.167l1.97 8.647h6.039V16.72z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.91 14.317h10.73l.986-4.406a2.327 2.327 0 01-1.199-.367 2.36 2.36 0 01-.84-.937l-4.821 3.285-3.8-7.426a2.3 2.3 0 01-1.04.269l-.017 9.582z",
    fill: "#FFB24D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.386 8.707a2.39 2.39 0 00-.365-2.822 2.324 2.324 0 00-2.784-.43 2.36 2.36 0 00-1.02 1.09 2.392 2.392 0 00.588 2.783c.383.337.864.54 1.371.576h.168c.415.001.822-.11 1.181-.32.359-.21.656-.513.861-.877zm9.491-3.969h.05a2.3 2.3 0 001.04-.269 2.359 2.359 0 001.052-1.125 2.391 2.391 0 00.14-1.542 2.372 2.372 0 00-.833-1.3A2.33 2.33 0 0013.877 0v4.738z",
    fill: "#FF9A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.877 0a2.327 2.327 0 00-1.463.523 2.388 2.388 0 00-.631 2.89c.235.482.626.869 1.109 1.096.307.15.644.228.985.23V0z",
    fill: "#FFB24D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.603 9.911h.052c.464 0 .917-.139 1.303-.399.385-.26.686-.63.863-1.063a2.391 2.391 0 00-.508-2.582 2.322 2.322 0 00-2.555-.514 2.35 2.35 0 00-1.052.873 2.387 2.387 0 00.698 3.319c.36.23.774.356 1.199.366z",
    fill: "#FF9A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12 18.552v3.951a.73.73 0 00.21.512.712.712 0 00.506.212h5.35v-4.675H4.12z",
    fill: "#FFB24D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.623 14.317h-15.06c-.63 0-1.235.253-1.681.704a2.415 2.415 0 00-.697 1.699v9.878c0 .637.251 1.248.697 1.698.446.45 1.05.704 1.681.704h15.06a2.36 2.36 0 001.68-.704c.447-.45.697-1.061.697-1.698V16.72c0-.637-.25-1.248-.696-1.699a2.365 2.365 0 00-1.681-.704zM18.1 25.33a.297.297 0 01-.158-.043.33.33 0 01-.17-.295v-6.056a.334.334 0 01.498-.295l4.598 3.026a.33.33 0 01.158.284.335.335 0 01-.158.283l-4.598 3.03a.355.355 0 01-.18.066h.01z",
    fill: "#5560FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.854 22.248a.33.33 0 00.158-.284.335.335 0 00-.158-.284l-4.597-3.026a.326.326 0 00-.328 0 .33.33 0 00-.171.296v6.055a.335.335 0 00.328.339.355.355 0 00.178-.053l4.59-3.043z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrownPlay);
export default __webpack_public_path__ + "static/media/Icon-crown-play.f916e303.svg";
export { ForwardRef as ReactComponent };